import { exportGroupedExcel } from "../../../../../utils/export/groupedExcel";
import { EXPENSE_COLUMNS, getExpenseCells } from "./ExpensesPdf";

// Summary sheet + one sheet per expense type (Expenses 1), each a single
// table of that type's expenses
export default function exportExpensesExcel({ records, meta }) {
  return exportGroupedExcel(records, meta, {
    groupLabel: "Expense Type",
    countLabel: "No. of Expenses",
    getGroup: (row) => ({
      key: row.expenses2?.expenses_one?.expenses_one_id,
      name: row.expenses2?.expenses_one?.expenses_type_one,
    }),
    getCurrency: (row) => row.currency_name,
    getAmount: (row) => row.totalAmount,
    tableColumns: EXPENSE_COLUMNS,
    buildBlockRows: (row) => [getExpenseCells(row)],
  });
}
